/**
 * Mobiele zoek-overlay — fallback als inline snippet niet booted.
 * Verplaatst #uf-header-search-panel naar body + dim backdrop.
 */
(function () {
  if (window.__ufMobileSearchBooted) return;
  window.__ufMobileSearchBooted = true;
  window.__ufMobileSearchOverlayBooted = true;

  var LAYER_ID = 'uf-mobile-search-layer';
  var LAYER_OPEN_CSS =
    'display:block!important;position:fixed!important;inset:0!important;z-index:2147483000!important;' +
    'width:100%!important;height:100%!important;max-height:100dvh!important;margin:0!important;padding:0!important;' +
    'background:rgba(48,34,22,0.52)!important;overflow-x:hidden!important;overflow-y:auto!important;' +
    'box-sizing:border-box!important;transform:none!important;filter:none!important;pointer-events:auto!important;';

  function usesOverlay() {
    try {
      return (
        window.matchMedia('(max-width: 991px)').matches ||
        document.documentElement.classList.contains('uf-header-middle-compact')
      );
    } catch (e) {
      return true;
    }
  }

  function getPanel() {
    return document.getElementById('uf-header-search-panel');
  }

  function ensureLayer() {
    var layer = document.getElementById(LAYER_ID);
    if (layer) return layer;
    layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.className = 'uf-mobile-search-layer';
    layer.setAttribute('role', 'presentation');
    (document.body || document.documentElement).appendChild(layer);
    return layer;
  }

  function resultsInOverlay() {
    var layer = document.getElementById(LAYER_ID);
    return document.body.classList.contains('uf-mobile-search-open') ||
      !!(layer && layer.classList.contains('is-open'));
  }

  function forceShowResults(box) {
    if (!box) return;
    box.removeAttribute('hidden');
    box.style.setProperty('display', 'block', 'important');
    box.style.setProperty('visibility', 'visible', 'important');
    box.style.setProperty('opacity', '1', 'important');
    box.style.setProperty('width', '100%', 'important');
    box.style.setProperty('overflow-y', 'auto', 'important');
    if (resultsInOverlay()) {
      box.style.setProperty('position', 'relative', 'important');
      box.style.setProperty('top', 'auto', 'important');
      box.style.setProperty('left', 'auto', 'important');
      box.style.setProperty('right', 'auto', 'important');
      box.style.setProperty('max-height', 'min(70vh, 520px)', 'important');
      box.style.setProperty('z-index', '5', 'important');
    } else {
      box.style.setProperty('position', 'absolute', 'important');
      box.style.setProperty('top', 'calc(100% + 0.45rem)', 'important');
      box.style.setProperty('left', '0', 'important');
      box.style.setProperty('right', '0', 'important');
      box.style.setProperty('max-height', 'min(62vh, 440px)', 'important');
      box.style.setProperty('z-index', '1100', 'important');
    }
  }

  function openOverlay() {
    var panel = getPanel();
    if (!panel) return;

    var layer = ensureLayer();

    if (!panel._ufHomeMarker && panel.parentNode && panel.parentNode.id !== LAYER_ID) {
      var marker = document.createComment('uf-search-home');
      panel.parentNode.insertBefore(marker, panel);
      panel._ufHomeMarker = marker;
    }

    if (panel.parentNode !== layer) {
      layer.appendChild(panel);
    }

    layer.classList.add('is-open');
    layer.style.cssText = LAYER_OPEN_CSS;

    panel.classList.add('searchdown', 'open');
    panel.style.setProperty('display', 'block', 'important');
    panel.style.setProperty('height', 'auto', 'important');
    panel.style.setProperty('max-height', 'none', 'important');
    panel.style.setProperty('min-height', '0', 'important');
    panel.style.setProperty('overflow', 'visible', 'important');
    panel.style.setProperty('margin', '0', 'important');
    panel.style.setProperty('line-height', 'normal', 'important');
    panel.style.setProperty('width', '100%', 'important');
    panel.style.setProperty('max-width', 'none', 'important');
    panel.style.setProperty('float', 'none', 'important');
    panel.style.setProperty('position', 'relative', 'important');
    panel.style.setProperty(
      'padding',
      'max(1.5rem, calc(env(safe-area-inset-top, 0px) + 1.25rem)) max(1.15rem, calc(env(safe-area-inset-right, 0px) + 1rem)) max(1.15rem, calc(env(safe-area-inset-bottom, 0px) + 1rem)) max(1.15rem, calc(env(safe-area-inset-left, 0px) + 1rem))',
      'important'
    );
    panel.style.setProperty('box-sizing', 'border-box', 'important');
    panel.style.setProperty('pointer-events', 'auto', 'important');
    panel.style.setProperty('background', 'transparent', 'important');

    var form = panel.querySelector('form');
    if (form) {
      form.style.setProperty('display', 'flex', 'important');
      form.style.setProperty('flex-direction', 'column', 'important');
      form.style.setProperty('gap', '0.85rem', 'important');
      form.style.setProperty('width', '100%', 'important');
      form.style.setProperty('margin', '0', 'important');
      form.style.setProperty('float', 'none', 'important');
    }

    var top = panel.querySelector('.uf-header-search__top');
    if (top) {
      top.style.setProperty('display', 'flex', 'important');
      top.style.setProperty('align-items', 'center', 'important');
      top.style.setProperty('gap', '0.65rem', 'important');
      top.style.setProperty('width', '100%', 'important');
    }

    var closeBtn = panel.querySelector('.uf-mobile-search-close');
    if (closeBtn) {
      closeBtn.style.setProperty('display', 'inline-flex', 'important');
      closeBtn.style.setProperty('position', 'static', 'important');
      closeBtn.style.setProperty('flex', '0 0 auto', 'important');
      closeBtn.style.setProperty('width', '44px', 'important');
      closeBtn.style.setProperty('height', '44px', 'important');
    }

    document.documentElement.classList.add('uf-mobile-search-open');
    document.body.classList.add('uf-mobile-search-open');
    document.body.classList.remove('search-overlay-show');

    var trigger = document.getElementById('searchlink');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var box = panel.querySelector('#autocomplete-results, .results-box');
    if (box && !box._ufObserved && window.MutationObserver) {
      box._ufObserved = true;
      new MutationObserver(function () {
        if (box.childNodes.length) forceShowResults(box);
      }).observe(box, { childList: true, subtree: true });
    }
    if (box && box.childNodes.length) forceShowResults(box);

    window.setTimeout(function () {
      var input = panel.querySelector('#search_query');
      if (input) {
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          input.focus();
        }
      }
    }, 60);
  }

  function closeOverlay() {
    var panel = getPanel();
    var layer = document.getElementById(LAYER_ID);

    document.documentElement.classList.remove('uf-mobile-search-open');
    document.body.classList.remove('uf-mobile-search-open', 'search-overlay-show');

    if (panel) {
      panel.classList.remove('searchdown', 'open');
      panel.removeAttribute('style');
      var form = panel.querySelector('form');
      if (form) form.removeAttribute('style');
      var top = panel.querySelector('.uf-header-search__top');
      if (top) top.removeAttribute('style');
      var closeBtn = panel.querySelector('.uf-mobile-search-close');
      if (closeBtn) closeBtn.removeAttribute('style');

      var box = panel.querySelector('#autocomplete-results, .results-box');
      if (box) {
        box.innerHTML = '';
        box.setAttribute('hidden', '');
        box.removeAttribute('style');
      }
      var input = panel.querySelector('#search_query');
      if (input) {
        input.value = '';
        if (window.jQuery) window.jQuery(input).removeData('oldval');
      }

      var marker = panel._ufHomeMarker;
      if (marker && marker.parentNode) {
        marker.parentNode.insertBefore(panel, marker);
        marker.parentNode.removeChild(marker);
      }
      panel._ufHomeMarker = null;
    }

    if (layer) {
      layer.classList.remove('is-open');
      layer.style.setProperty('display', 'none', 'important');
    }

    var trigger = document.getElementById('searchlink');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function isOpen() {
    return document.body.classList.contains('uf-mobile-search-open');
  }

  function setOpen(open) {
    if (!usesOverlay()) {
      var panel = getPanel();
      if (!panel) return;
      if (open) {
        panel.classList.add('searchdown', 'open');
        var input = panel.querySelector('#search_query');
        if (input) input.focus();
      } else {
        panel.classList.remove('searchdown', 'open');
      }
      return;
    }
    if (open) openOverlay();
    else closeOverlay();
  }

  function showResults($box) {
    var el = $box && $box.jquery ? $box[0] : $box;
    if (!el) {
      var p = getPanel();
      el = p && p.querySelector('#autocomplete-results, .results-box');
    }
    forceShowResults(el);
    if ($box && $box.jquery) {
      $box.removeAttr('hidden').css({ display: 'block', visibility: 'visible', opacity: '1' });
    }
  }

  function hideResults($box, clear) {
    var el = $box && $box.jquery ? $box[0] : $box;
    if (!el) {
      var p = getPanel();
      el = p && p.querySelector('#autocomplete-results, .results-box');
    }
    if (!el) return;
    if (clear) el.innerHTML = '';
    el.setAttribute('hidden', '');
    el.style.display = '';
    if ($box && $box.jquery) {
      if (clear) $box.empty();
      $box.attr('hidden', 'hidden').css('display', '');
    }
  }

  function bindApi() {
    window.ufMobileSearchOverlayReady = true;
    window.ufMobileSearchOverlaySetOpen = setOpen;
    window.ufSetMobileSearchOpen = setOpen;
    window.ufShowHeaderSearchResults = showResults;
    window.ufHideHeaderSearchResults = hideResults;
  }

  bindApi();

  var n = 0;
  var t = window.setInterval(function () {
    bindApi();
    n += 1;
    if (n > 80) window.clearInterval(t);
  }, 100);

  document.addEventListener(
    'click',
    function (e) {
      var tEl = e.target;
      if (!tEl || !tEl.closest) return;

      var closeBtn = tEl.closest('.uf-mobile-search-close, #uf-mobile-search-layer .search-close');
      if (closeBtn && usesOverlay()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setOpen(false);
        return;
      }

      var layer = document.getElementById(LAYER_ID);
      if (layer && layer.classList.contains('is-open') && tEl === layer) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setOpen(false);
        return;
      }

      var trigger = tEl.closest('#searchlink, #searchlink-legacy');
      if (!trigger || !usesOverlay()) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      setOpen(!isOpen());
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen() && usesOverlay()) {
      e.preventDefault();
      setOpen(false);
    }
  });
})();
